export default __webpack_public_path__ + "static/media/md-color-palette.28927f21.svg";